module.exports = {
    //1
    validateAttendee:{
        fieldName:"validateAttendee",
        name:"报名验证码",
        help:"开启后, 活动报名时需填写验证码，每次扣除主办方1签币",
        //url: "https://img.qdj8.cn/03.jpg",
        switch:["开启","未开启"],
        initialValue: false,
    },
    //2
    /*validateCheckin: {
        fieldName:"validateCheckin",
        name:"签到时验证",
        help:"开启后，参与人扫描【签到二维码】签到时需填写手机（或邮箱）和短信验证码",
        switch:["开启","未开启"],
    },*/
    //3
    allowDirectCheckin: {
        fieldName:"allowDirectCheckin",
        name:"直接签到",
        help:"允许后，未报名的活动参与人扫描【签到二维码】可以同时完成报名和签到动作；如果不允许，则只有在参与人名单中的人才能签到 <a href='https://www.yuque.com/odh2xi/manual/rq93cagvwtqocxv5#g6qBW' target=\"_Blank\" >  详细帮助</a>",
        //url: 'https://img.qdj8.cn/08_1.jpg',
        switch:["允许","不允许"],
        initialValue: false,
    },
    directCheckinUniqueFieldOnly: {
        fieldName:"directCheckinUniqueFieldOnly",
        name:"直接签到方式",
        help:"补充信息：签到时直接填写所有信息；唯一字段：签到时先填写唯一字段，若不在名单，进入补充信息流程，若在则直接签到成功",
        // url: 'https://img.qdj8.cn/08.jpg',
        switch:["补充信息","唯一字段"],
        initialValue: false,
    },
    directCheckinWxZeroInput: {
        fieldName:"directCheckinWxZeroInput",
        name:"微信自动匹配",
        help:"开启后，参与人微信扫码自动采集微信编码（该信息不可用户添加好友），昵称、头像，性别和城市（如有），不用任何输入信息，即可签到；高级会员可用<a href='https://www.yuque.com/odh2xi/manual/rdi3faeuc977n8vu#gsTJA' target=\"_Blank\" >  详细帮助</a>",
        // url: 'https://img.qdj8.cn/08.jpg',
        switch:["开启","关闭"],
        initialValue: false,
    },
    //4
    approveCheckin: {
        fieldName:"approveCheckin",
        name:"主办方签到审核",
        help:"开启后，只允许主办方扫码签到，且会先展示参与人信息，由主办方判断是否签到，适用于需要扫码确认信息，再选择是否签到的流程。重要提示：开启此项，参与人无法自助扫码签到！",
        switch:["开启","未开启"],
        initialValue: false,
    },
    //5
    allowRepeatCheckin: {
        fieldName:"allowRepeatCheckin",
        name:"重复签到",
        help:"允许后，同一参与人可进行不限次重复签到",
        url: 'https://img.qdj8.cn/06.jpg',
        switch:["允许","不允许"],
        initialValue: true,
    },
    //6
    allowUniqueFieldCheckin: {
        fieldName:"allowUniqueFieldCheckin",
        name:"签到验证码",
        help:"参与人签到需要验证码，扣除主办方1个签币",
        url: "", //'https://img.qdj8.cn/09.jpg',
        switch:["需要","不需要"],
        initialValue: false,
    },
    enableFindTicketCaptcha: {
        fieldName:"enableFindTicketCaptcha",
        name:"找回凭证验证码",
        help:"设置参与人扫码找回报名凭证时，是否需要验证码",
        url: "", //'https://img.qdj8.cn/09.jpg',
        switch:["需要","不需要"],
        initialValue: false,
    },
    allowUniqueFieldQuickCheckin: {
        fieldName:"allowUniqueFieldQuickCheckin",
        name:"参与人后四位签到",
        help:"允许后，参与人可以扫码后可以输入后4位进行签到。一般唯一字段是：手机或数字类才适用，其他建议关闭",
        url: 'https://img.qdj8.cn/10_1.jpg',
        switch:["允许","不允许"],
        initialValue: false,
    },
    allowUniqueFieldLikeCheckin: {
        fieldName:"allowUniqueFieldLikeCheckin",
        name:"参与人模糊签到",
        help:"允许后，参与人可以扫码后可以输入任意两位以上的信息查找，选择，签到。（很适合姓名签到的情况）",
        url: null,
        switch:["允许","不允许"],
        initialValue: false,
    },
    enableReplenishForm: {
        fieldName:"enableReplenishForm",
        name:"开启签到后填写表单",
        help:"参与人每次签到后都需填写信息，如：每次签到填写体温；每次巡检上传现场照片等",
        url: null,
        switch:["开启","关闭"],
        initialValue: false,
    },
    //7
    hidePersonalInfo:{
        fieldName:"hidePersonalInfo",
        name:"隐藏报名人列表",
        help:"选择关闭时，参与人报名的时候，可以看到其他已经报名的人",
        switch:["隐藏","不隐藏"],
        initialValue: false,
    },

    hideAttendee:{
        fieldName:"hideAttendee",
        name:"显示报名名单",
        help:"开启后可在活动详情页面查看，可以看到已报名单",
        url: 'https://img.qdj8.cn/04.jpg',
        switch:["开启","未开启"],
        initialValue: false,
    },
    enableInviteeStatistics:{
        fieldName:"enableInviteeStatistics",
        name:"微信邀请渠道",
        help:"开启后可在活动详情页面查看，报名人的邀请渠道<a href='https://www.yuque.com/odh2xi/manual/rq93cagvwtqocxv5#nomAd' target=\"_Blank\" >  详细帮助</a>",
        // url: 'https://img.qdj8.cn/04.jpg',
        switch:["开启","未开启"],
        initialValue: false,
    },
    //9
    approveAttendee:{
        fieldName:"approveAttendee",
        name:"报名需审核",
        help:"开启后，报名或购票支付完成的用户，需要主办方审核",
        url: 'https://img.qdj8.cn/05.jpg',
        switch:["开启","未开启"],
        initialValue: false,
    },
    //9 1111
    avatarMandatory:{
        fieldName:"avatarMandatory",
        name:"报名上传头像",
        help:"开启后，报名或购票时需要用户上传头像",
        url:null,
        switch:["开启","未开启"],
        initialValue: false,
    },
    faceOpen:{
        fieldName:"faceOpen",
        name:"开启人脸识别",
        help:"开启后，报名上传的头像将做人脸检测，可用于人脸识别签到等；每签到成功一次，扣除主办方10签币。<a href='https://www.yuque.com/odh2xi/manual/rdi3faeuc977n8vu#Ke5Ur' target=\"_Blank\" >  详细帮助</a>",
        url:null,
        switch:["开启","未开启"],
        initialValue: false,
    },
    //9 1111
    sendAttendConfirm:{
        fieldName:"sendAttendConfirm",
        name:"报名成功推送信息",
        help:"开启后，报名或购票成功时，自动向参与人推送二维码等凭证（短信/邮件 消耗主办方签币）",
        //url: 'https://img.qdj8.cn/01.jpg',
        switch:["开启","未开启"],
        initialValue: false,
    },
    enabledShareCode:{
        fieldName:"enabledShareCode",
        name:"报名邀请码",
        help:"开启后，报名需要填写邀请码才能报名，可在下方定义名称<a href='https://www.yuque.com/odh2xi/manual/rdi3faeuc977n8vu#CclZs' target=\"_Blank\" >  详细帮助</a>",
        switch:["开启","未开启"],
        initialValue: false,
    },
    mustShareCode:{
        fieldName:"mustShareCode",
        name:"邀请码是否必填",
        help:"控制报名时，是否必须填写邀请码",
        switch:["必填","非必填"],
        initialValue: true,
    },
    enableComment:{
        fieldName:"enableComment",
        name:"显示评论信息",
        help:"开启在活动详情可以对活动进行评论",
        switch:["开启","未开启"],
        initialValue: false,
    },
    enableAttendeeInvoice:{
        fieldName:"enableAttendeeInvoice",
        name:"活动发票管理",
        help:"参与人报名后，可提交发票信息，支持导出Excel，发票由您自行开具",
        switch:["开启","未开启"],
        initialValue: false,
    },
    sendAttendSignInConfirm:{
        fieldName:"sendAttendSignInConfirm",
        name:"签到通知",
        help:"开启后，签到成功时，参与者将收到相关信息短信/邮件通知（消耗主办方签币），这里一般通知给参与者本人",
        // url: 'https://img.qdj8.cn/01.jpg',
        switch:["开启","未开启"],
        initialValue: false,
    },
    sendAllotReceiver:{
        fieldName:"sendAllotReceiver",
        name:"接待人通知",
        help:"开启后，签到成功时，会自动推送信息给会议接待人员，接待人员接收手机号码固定「分配管理」中设置（消耗主办方签币）",
        // url: 'https://img.qdj8.cn/01.jpg',
        switch:["开启","未开启"],
        initialValue: false,
    },
    allowBatchAttend:{
        fieldName:"batchAttend",
        name:"代报名/团体报名",
        help:"开启后，将允许替他人一起报名或购票。<a href='https://www.yuque.com/odh2xi/manual/rdi3faeuc977n8vu#IAZ2d' target=\"_Blank\" >  详细帮助</a>",
        //url: null,
        switch:["开启","未开启"],
        initialValue: false,
    },
    allowAttendeeEditForm:{
        fieldName:"allowAttendeeEditForm",
        name:"报名信息修改",
        //url: null,
        help:"报名后，允许参与人自助修改信息，如同时打开了报名需审核，则修改信息还需要审核一次。<a href='https://www.yuque.com/odh2xi/manual/rdi3faeuc977n8vu#aYfOc' target=\"_Blank\" >  详细帮助</a>",
        url: null,
        switch:["开启","未开启"],
        initialValue: false,
    },
    onlyWxSignUp:{
        fieldName:"onlyWxSignUp",
        name:"仅微信报名",
        help:"开启后，参与人仅能使用手机微信进行报名",
        url: null,
        switch:["开启","未开启"],
        initialValue: false,
    },
    onlyWxCheckIn:{
        fieldName:"onlyWxCheckIn",
        name:"仅微信签到",
        help:"开启后，参与人仅能使用手机微信进行签到",
        url: null,
        switch:["开启","未开启"],
        initialValue: false,
    },
    enabledAttendeeUnbinding:{
        fieldName:"enabledAttendeeUnbinding",
        name:"微信解绑",
        help:"开启后，参与人解绑微信和该活动的关联，可输入其他人信息代签",
        url: null,
        switch:["开启","未开启"],
        initialValue: false,
    },
    enablePositionRecord:{
        fieldName:"enablePositionRecord",
        name:"签到时记录地理",
        help:"开启后，每次签到时会记录地理定位，如：防疫时每日签到人员是否离开指定区域",
        url: null,
        switch:["开启","未开启"],
        initialValue: false,
    },
}


// WEBPACK FOOTER //
// ./src/containers/evt/EvtConfigDes.js